import { render, staticRenderFns } from "./SettingCrypto.vue?vue&type=template&id=f624df06&"
import script from "./SettingCrypto.vue?vue&type=script&lang=js&"
export * from "./SettingCrypto.vue?vue&type=script&lang=js&"
import style0 from "./SettingCrypto.vue?vue&type=style&index=0&id=f624df06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports